import { TimezoneService, ResourceProvider, HttpService } from "@sportal/api";

export const makeTimezoneService = (http: HttpService): TimezoneService =>
  new TimezoneService(new ResourceProvider(http));
